/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MemberAddRequest
 */
export interface MemberAddRequest {
    /**
     * The name of the user to invite
     * @type {string}
     * @memberof MemberAddRequest
     */
    name: string;
    /**
     * The email address used to invite this user
     * @type {string}
     * @memberof MemberAddRequest
     */
    email: string;
    /**
     * The role to assign to the new member
     * @type {string}
     * @memberof MemberAddRequest
     */
    role: MemberAddRequestRoleEnum;
}


/**
 * @export
 */
export const MemberAddRequestRoleEnum = {
    Owner: 'OWNER',
    BillingManager: 'BILLING_MANAGER',
    Member: 'MEMBER'
} as const;
export type MemberAddRequestRoleEnum = typeof MemberAddRequestRoleEnum[keyof typeof MemberAddRequestRoleEnum];


/**
 * Check if a given object implements the MemberAddRequest interface.
 */
export function instanceOfMemberAddRequest(value: object): value is MemberAddRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    return true;
}

export function MemberAddRequestFromJSON(json: any): MemberAddRequest {
    return MemberAddRequestFromJSONTyped(json, false);
}

export function MemberAddRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MemberAddRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'email': json['email'],
        'role': json['role'],
    };
}

export function MemberAddRequestToJSON(json: any): MemberAddRequest {
    return MemberAddRequestToJSONTyped(json, false);
}

export function MemberAddRequestToJSONTyped(value?: MemberAddRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'email': value['email'],
        'role': value['role'],
    };
}

